// App.js
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import "./App.css";
import MainLayout from "./layout/MainLayout";
import Login from "./Pages/Login";
import "antd/dist/reset.css"; // for AntD v5+
import Unauthorized from "./Pages/Unauthorized";
// import { ConfigProvider, theme } from "antd";

function ProtectedRoute({ children }) {
  const user = localStorage.getItem("auth_user");
  return user ? children : <Navigate to="/login" replace />;
}

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/unauthorized" element={<Unauthorized />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
